import type { SVGProps } from 'react';
const SvgFineMotor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      clipPath="url(#fine-motor_svg__a)"
    >
      <path d="M10.5 4.75a1.25 1.25 0 0 1 2.5 0V9.5a5 5 0 0 1-5 5c-2.761 0-3.797-1.33-5.832-5.625a1.25 1.25 0 0 1 2.165-1.25L5.5 9.5V3.75a1.25 1.25 0 1 1 2.5 0" />
      <path d="M8 7.5V2.75a1.25 1.25 0 0 1 2.5 0V7.5" />
    </g>
    <defs>
      <clipPath id="fine-motor_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFineMotor;
